import { Slider } from "@mui/material";
import React, { useEffect, useState } from "react";
import { FormField } from "ui/Scripts/source/components/framework/FormField";
import { TaskTypeClassHidden, TaskTypeClassWidthPrefix } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";
import { getMobileWidthFromClass, getPrintWidthFromClass, getUpdatedClassForWidth, getWebWidthFromClass } from "../../FormDesignerTypes";

interface IFormDesignerComponentPropertiesWidthProps {
    id: string;
    classes: string;
    formFieldMargin: number | string;
    sizePrefix: TaskTypeClassWidthPrefix;
    minimum?: number;
    maximum?: number;
    title: string;
    previewMode?: boolean;
    onUpdate: (id: string, classes: string) => void;
}

//TODO: Check custom width classes handling
export const FormDesignerComponentPropertiesWidth = ({
    id,
    classes,
    formFieldMargin,
    sizePrefix,
    minimum = 1,
    maximum = 12,
    title,
    previewMode,
    onUpdate,
}: IFormDesignerComponentPropertiesWidthProps) => {
    const [width, setWidth] = useState(0);

    useEffect(() => {
        const w = sizePrefix === TaskTypeClassWidthPrefix.Web || sizePrefix === TaskTypeClassWidthPrefix.Web2
            ? getWebWidthFromClass(classes) || 0
            : (sizePrefix === TaskTypeClassWidthPrefix.Mobile
                ? getMobileWidthFromClass(classes)
                : getPrintWidthFromClass(classes)
            );
        setWidth(Math.min(Math.max(w, minimum), maximum));
    }, [classes, sizePrefix]);

    const handleSliderChange = (_event: Event, newValue: number) => {
        setWidth(newValue > maximum ? maximum : newValue);
    };

    const handleSliderChangeCommited = (_event: Event, newValue: number) => {
        const isWebPrefix = sizePrefix === TaskTypeClassWidthPrefix.Web || sizePrefix === TaskTypeClassWidthPrefix.Web2;
        const removeSizePrefixes = isWebPrefix && !previewMode
            ? [TaskTypeClassWidthPrefix.Web, TaskTypeClassWidthPrefix.Web2, TaskTypeClassWidthPrefix.Mobile, TaskTypeClassWidthPrefix.Print]
            : [sizePrefix];
        const ignoreSizePrefixes = sizePrefix === TaskTypeClassWidthPrefix.Mobile
            ? [TaskTypeClassWidthPrefix.Web, TaskTypeClassWidthPrefix.Web2]
            : [];
        const hiddenStyle = isWebPrefix
            ? TaskTypeClassHidden.Web
            : (sizePrefix === TaskTypeClassWidthPrefix.Mobile
                ? TaskTypeClassHidden.Mobile
                : TaskTypeClassHidden.Print
            );
        onUpdate(id, getUpdatedClassForWidth(classes, removeSizePrefixes, ignoreSizePrefixes, sizePrefix, hiddenStyle, newValue > maximum ? maximum : newValue, width, previewMode));
    };

    return (
        <FormField title={title + (width > 0 ? "" : (" (" + Translations.Hidden + ")"))} overflow="visible" margin={formFieldMargin}>
            <Slider
                value={width}
                onChange={handleSliderChange}
                onChangeCommitted={handleSliderChangeCommited}
                valueLabelDisplay="auto"
                step={1}
                min={minimum}
                max={maximum}
            />
        </FormField>
    );
};
